import VueCookies from "vue-cookies";
import { resolveCookieDomain } from "@/core/loginStrategy";

export const TOKEN_KEY = "tokenWeb";
export const REFRESH_TOKEN_KEY = "tokenWebRefresh";
export const USER_INFO_KEY = "userInfo";

const TOKEN_TTL_SECONDS = 24 * 60 * 60;
const REFRESH_TOKEN_TTL_SECONDS = 25 * 60 * 60;

function getCookieDomain() {
  return resolveCookieDomain();
}

function getCookieOptions(expires) {
  const domain = getCookieDomain();
  const options = { expires };
  if (domain) {
    options.domain = domain;
  }
  return options;
}

export function setAuthCookie(key, value, expires = TOKEN_TTL_SECONDS) {
  VueCookies.set(key, value, getCookieOptions(expires));
}

export function removeAuthCookie(key) {
  const domain = getCookieDomain();
  if (domain) {
    VueCookies.remove(key, "/", domain);
  }
  VueCookies.remove(key);
}

export function getAuthCookie(key) {
  return VueCookies.get(key);
}

export function isLoggedIn() {
  return !!getAuthCookie(TOKEN_KEY) && !!getAuthCookie(USER_INFO_KEY);
}

export function clearAuthCookies() {
  removeAuthCookie(TOKEN_KEY);
  removeAuthCookie(REFRESH_TOKEN_KEY);
  removeAuthCookie(USER_INFO_KEY);
}

export function parseUserInfoCookie() {
  const raw = getAuthCookie(USER_INFO_KEY);
  if (!raw) {
    return null;
  }
  try {
    return typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }
}

export function getCurrentUserId() {
  const userInfo = parseUserInfoCookie();
  if (!userInfo) {
    return null;
  }
  return userInfo.userId ?? userInfo.id ?? userInfo.ringUserId ?? null;
}

export function writeTokenCookies(accessToken) {
  setAuthCookie(TOKEN_KEY, accessToken, TOKEN_TTL_SECONDS);
  setAuthCookie(REFRESH_TOKEN_KEY, accessToken, REFRESH_TOKEN_TTL_SECONDS);
}

export function writeUserInfoCookie(userInfo) {
  if (!userInfo) {
    return;
  }
  const value =
    typeof userInfo === "string" ? userInfo : JSON.stringify(userInfo);
  setAuthCookie(USER_INFO_KEY, value, TOKEN_TTL_SECONDS);
}
